const KEY = "ais_oral_project_context_v1";

export function loadProjectContext() {
  try {
    return localStorage.getItem(KEY) || "";
  } catch (err) {
    console.error("[projectContext] read failed", err);
    return "";
  }
}

export function saveProjectContext(text) {
  try {
    const trimmed = (text || "").trim();
    if (!trimmed) {
      localStorage.removeItem(KEY);
    } else {
      localStorage.setItem(KEY, trimmed);
    }
  } catch (err) {
    console.error("[projectContext] write failed", err);
  }
}
